export type ThemePreference = 'light' | 'dark';

export const setThemePreference = (preference: ThemePreference) => ({
  type: 'app/theme/SET_PREFERENCE' as const,
  payload: { preference },
});
